import { Component } from '@angular/core';

@Component({
  selector: 'webapp-compat-navigation-secondary-contests',
  template: `
    <app-navigation-secondary-contests></app-navigation-secondary-contests>
    <router-outlet></router-outlet>
  `,
})
export class CompatNavigationSecondaryContestsComponent {}



// WEBPACK FOOTER //
// /mnt/jenkins-slave-workspace/workspace/gaf-build-i18n-webapp-compat/LANG/it/webapp/src/compat/compat-navigation-secondary-contests.component.ts